import { navItems } from "@/mocks/siteContent";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-marked-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                夏目彩春 · 动态追踪
              </span>
            </div>
            <p className="mt-4 text-xs md:text-sm text-secondary-200 leading-relaxed max-w-md">
              围绕夏目彩春的个人资料、ins 账号线索、最新动态与网络热议话题整理而成的单页信息站，
              内容来自公开网络渠道，仅供参考，请以官方信息为准。
            </p>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-label text-xs tracking-widest uppercase text-secondary-300">
              页面导航
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-xs md:text-sm text-secondary-100 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#about"
                  className="text-xs md:text-sm text-secondary-100 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  免责说明
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-label text-xs tracking-widest uppercase text-secondary-300">
              内容声明
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li className="flex items-start gap-2 text-xs md:text-sm text-secondary-200 leading-relaxed">
                <i className="ri-checkbox-blank-circle-fill text-[6px] mt-1.5 text-primary-400"></i>
                <span>不生产、不证实任何爆料</span>
              </li>
              <li className="flex items-start gap-2 text-xs md:text-sm text-secondary-200 leading-relaxed">
                <i className="ri-checkbox-blank-circle-fill text-[6px] mt-1.5 text-primary-400"></i>
                <span>不收集访客个人信息</span>
              </li>
              <li className="flex items-start gap-2 text-xs md:text-sm text-secondary-200 leading-relaxed">
                <i className="ri-checkbox-blank-circle-fill text-[6px] mt-1.5 text-primary-400"></i>
                <span>传闻内容均明确标注</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[11px] md:text-xs text-secondary-300">
            © 2026 夏目彩春 · 动态追踪　内容整理自公开网络，仅供参考
          </p>
          <p className="text-[11px] md:text-xs text-secondary-300">
            本页面为信息汇总展示，不含任何交易或提交功能
          </p>
        </div>
      </div>
    </footer>
  );
}